import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Button,
  Typography,
  Paper,
  Alert,
  InputAdornment,
  IconButton,
} from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { useNavigate } from "react-router-dom";

const ADMIN_PASSWORD = "MaratonaPrime@123";

function Login() {
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  // Redirect if already authenticated
  useEffect(() => {
    const isAuthenticated = localStorage.getItem("adminAuthenticated") === "true";
    if (isAuthenticated) {
      navigate("/home", { replace: true });
    }
  }, [navigate]);

  const handleSubmit = (e) => {
    e.preventDefault();
    setError("");

    if (password === ADMIN_PASSWORD) {
      // Salvar autenticação no localStorage
      localStorage.setItem("adminAuthenticated", "true");
      // Redirecionar para página Início
      navigate("/home");
    } else {
      setError("Senha incorreta. Tente novamente.");
    }
  };

  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        width: "100%",
      }}
    >
      {/* Left Side - Motivational Background */}
      <Box
        sx={{
          width: "50%",
          backgroundImage: "url('/imobiliaria2.webp')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          display: { xs: "none", md: "block" },
          "&::before": {
            content: '""',
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: " rgba(0, 0, 0, 0.7)",
            opacity: 0.5,
          },
        }}
      >
        {/* Image overlay */}
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 1,
            textAlign: "center",
            width: "80%",
            maxWidth: 400,
          }}
        >
         
        </Box>
      </Box>

      {/* Right Side - Login Form */}
      <Box
        sx={{
          width: { xs: "100%", md: "50%" },
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#111111",
          p: 4,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            width: "100%",
            maxWidth: 450,
            p: 4,
            backgroundColor: "#ffffff",
            borderRadius: 3,
            boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
          }}
        >
          {/* Logo */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              mb: 3,
            }}
          >
            <Box
              component="img"
              src="/logoletraspretas.webp"
              alt="Prime Class Imobiliária"
              sx={{
                height: 60,
                width: "auto",
                maxWidth: "100%",
              }}
              onError={(e) => {
                e.target.style.display = "none";
              }}
            />
          </Box>

          {/* Welcome Message */}
          <Typography
            variant="h4"
            sx={{
              fontWeight: "bold",
              color: "#2d2d2d",
              textAlign: "center",
              mb: 1,
            }}
          >
            Bem-vindo!
          </Typography>

          <Typography
            variant="body2"
            sx={{
              color: "#757575",
              textAlign: "center",
              mb: 4,
            }}
          >
            Faça login para acessar o sistema
          </Typography>

          <form onSubmit={handleSubmit}>
            {error && (
              <Alert severity="error" sx={{ mb: 2, borderRadius: 2 }}>
                {error}
              </Alert>
            )}

            {/* Password Field */}
            <TextField
              fullWidth
              type={showPassword ? "text" : "password"}
              label="Senha"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              InputProps={{
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                      sx={{
                        color: "#757575",
                        "&:hover": {
                          color: "#2196F3",
                        },
                      }}
                    >
                      {showPassword ? (
                        <VisibilityOffIcon />
                      ) : (
                        <VisibilityIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{
                mb: 2,
                "& .MuiOutlinedInput-root": {
                  backgroundColor: "#f5f5f5",
                  color: "#2d2d2d",
                  borderRadius: 2,
                  "& fieldset": {
                    borderColor: "#e0e0e0",
                  },
                  "&:hover fieldset": {
                    borderColor: "#bdbdbd",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#2196F3",
                  },
                },
                "& .MuiInputLabel-root": {
                  color: "#757575",
                },
                "& .MuiInputLabel-root.Mui-focused": {
                  color: "#2196F3",
                },
              }}
              autoFocus
            />

            {/* Login Button */}
            <Button
              type="submit"
              fullWidth
              variant="contained"
              sx={{
                background: "linear-gradient(180deg, #FF6E79 0%,rgb(235, 69, 83) 100%)",
                color: "#ffffff",
                py: 1.5,
                fontWeight: "bold",
                fontSize: "1rem",
                borderRadius: 2,
                textTransform: "none",
                boxShadow: "0 2px 8px rgba(33, 150, 243, 0.3)",
                "&:hover": {
                  background: "linear-gradient(180deg, #FF6E79 0%, rgb(235, 69, 83) 100%)",
                  boxShadow: "0 4px 12px rgba(33, 150, 243, 0.4)",
                },
              }}
            >
              Iniciar Sessão
            </Button>
          </form>

          {/* Footer Text */}
          <Box
            sx={{
              mt: 3,
              pt: 3,
              borderTop: "1px solid #e0e0e0",
              textAlign: "center",
            }}
          >
            <Typography
              variant="body2"
              sx={{
                color: "#757575",
                fontSize: "0.875rem",
              }}
            >
              Sistema desenvolvido para <a href="https://primeclassimobiliaria.com.br" target="_blank" 
              rel="noopener noreferrer" style={{ color: "#FF6E79", textDecoration: "none" }}>Prime Class Imobiliária</a>
            </Typography>
          </Box>
        </Paper>
      </Box>
    </Box>
  );
}

export default Login;
